module.exports = "https://static.energy5.com/_next/static/images/winterLogo-116869d42dceb8af29d7c0fd91d1eab7.png";